import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-privilege';

const merchantRights = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/rights`, data);
};

const rightItems = (merchantId, data, rightId) => {
	return Client.get(
		`${baseUrl}/${merchantId}/rights/${rightId}/right-items`,
		data
	);
};

const addRights = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/rights`, data);
};

const updateRights = (merchantId, data, rightId) => {
	return Client.put(`${baseUrl}/${merchantId}/rights/${rightId}`, data);
};

const addRightsItems = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/right-items`, data);
};

const updateRightItems = (merchantId, data, rightItemId) => {
	return Client.put(
		`${baseUrl}/${merchantId}/right-items/${rightItemId}`,
		data
	);
};

const deleteRightItems = (merchantId, rightItemId) => {
	return Client.del(`${baseUrl}/${merchantId}/right-items/${rightItemId}`);
};

export default {
	merchantRights,
	rightItems,
	addRights,
	updateRights,
	addRightsItems,
	updateRightItems,
	deleteRightItems,
};
